// @flow
import composeOperator from './composeOperator'

export default composeOperator

export {
  ADD,
  EDIT,
  DELETE,
  READ,
} from './constants'
